import { render, staticRenderFns } from "./ScreenPayIntro.vue?vue&type=template&id=30213817&scoped=true"
import script from "./ScreenPayIntro.vue?vue&type=script&lang=ts"
export * from "./ScreenPayIntro.vue?vue&type=script&lang=ts"
import style0 from "./ScreenPayIntro.vue?vue&type=style&index=0&id=30213817&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30213817",
  null
  
)

export default component.exports